import SelectionDialog from '@Components/General/SelectionDialog';
import Toolbar from '@Components/General/Toolbar';
import {
    Button,
    Stack,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SimpleSort from '@Components/Common/SimpleSort';
import useStateSimpleSort from '@hooks/useStateSimpleSort';
import useDefaultInfiniteQuery from '@hooks/useDefaultInfiniteQuery';
import { emailTemplateVariantsQueryOptions } from '@utils/queryOptions';
import TemplateList from './variants-list';

const TemplateVariants = ({
    selectedTemplate,
    setSelectedTemplate,
    onSelect,
    open,
    onClose,
}) => {
    const { t } = useTranslation();
    const [search, setSearch] = useState('');

    const simpleSortHook = useStateSimpleSort({
        inverseFields: ['created', 'updated'],
        defaultSortField: 'title',
    });

    const params = { search, ordering: simpleSortHook.ordering };

    const queryOptions = emailTemplateVariantsQueryOptions(
        selectedTemplate?.id,
        params,
    );

    const {
        data: { flatData: templates, count } = {},
        isLoading,
        fetchNextPage,
        isFetchingNextPage,
    } = useDefaultInfiniteQuery(queryOptions);

    if (!selectedTemplate) return null;

    return (
        <SelectionDialog
            open={open}
            onClose={onClose}
            title={t('headers.templateVariants', {
                templateTitle: selectedTemplate.parent_title,
                ns: 'prompts',
            })}
            searchProps={{
                searchPlacholder: t('Search Variants'),
                onSubmit: setSearch,
            }}
            toolbar={
                <Toolbar>
                    <Typography variant="titleMedium">
                        {count} {t('Variants')}
                    </Typography>
                    <SimpleSort
                        sortOptions={[
                            { value: 'title', label: t('Title') },
                            {
                                value: 'created',
                                label: t('Last Created'),
                            },
                            {
                                value: 'updated',
                                label: t('Last Updated'),
                            },
                        ]}
                        {...simpleSortHook}
                    />
                </Toolbar>
            }
        >
            <TemplateList
                templates={templates}
                loadMore={fetchNextPage}
                loadingNext={isFetchingNextPage}
                isLoading={isLoading}
                onSelect={onSelect}
                queryOptions={queryOptions}
                setSelectedTemplate={setSelectedTemplate}
            />
        </SelectionDialog>
    );
};

export default TemplateVariants;
